import React, {Component} from 'react';
import axios from 'axios';
import {withRouter} from 'react-router-dom';
import ReactGA from 'react-ga';

//import BootstrapTable from 'react-bootstrap-table-next';
//import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
//import paginationFactory from 'react-bootstrap-table2-paginator';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import {ToastContainer, ToastStore} from 'react-toasts';
import LostItemFunctions from '../LostItem/LostItemFunctions';
//import ExifOrientationImg from 'react-exif-orientation-img'
import {SERVER_URL}  from '../Constants';
import Pagination from "react-js-pagination";
import Modal from 'react-responsive-modal';



class PortalLostAndFound extends Component {

    constructor(props) {
      super(props);

      this.state = {
        activePage: 1,
        totalItemsCount:0,
        totalPerPage:12,
        pageRangeDisplayed:1,
        selectedItem: null,
        showCards: true,
       
        lostItems:[],
        filteredItems:[],
        filteredStatus:'',
        archiveCount:0,
        queueCount:0,
        claimCount:0,
        publishCount:0,
        allCount:0,
        showNewClaim:false,
        bgColor: (props.bgColor)? props.bgColor: 'black',
        
      };
  
      //console.log('Custom portal color:' + props.bgColor);
      this.rowEvents = {
        onClick: (e, row, rowIndex) => {
          
          //this.props.history.push('/LostItem/' + row.id);
          //console.log(this + ' ' + `clicked on row with index: ${rowIndex}`);
          
      
        },
        
    }

    }

    trackMe=(venuePublishID)=>{
        try {
            ReactGA.pageview('/PortalLostAndFound:' + venuePublishID);
        }catch(e){
            //dont care
           
        }
    }

 

    async componentDidMount() {
        try {
            //console.log(this.props);
            
            this.trackMe(this.props.venuePublishID);
           if (!this.props.venuePublishID){
               // nope
               this.setState({
                lostItems: [],
                filteredItems : [],
                pageRangeDisplayed: 0,
              
                });
                ToastStore.error("Invalid or missing portal id");

           }

        axios.get(SERVER_URL +  '/Portal/venuelf/' + this.props.venuePublishID).then((res)=>{
            
            if (res.status === 401) {
              //place your reentry code
              console.log("Error" + res.status);
             
             }
    
    
            const lostItems = res.data;
            if (lostItems){
              this.setState({
                lostItems: lostItems,
                filteredItems : lostItems,
                totalItemsCount: lostItems.length,
                allCount:lostItems.length,
                pageRangeDisplayed: (lostItems.length >0) ? Math.ceil(lostItems.length / this.state.totalPerPage) : 0
                });
            }
            }).catch((e)=>{ 
              //console.log("error " + e)
              ToastStore.error("An error occured. Please try again");
            });
          }
            catch(e){
              //ToastStore.error(e.response);
            }
        
    
        
     
      }
    renderToast=()=>{
        return <div>
            
            <ToastContainer position={ToastContainer.POSITION.TOP_RIGHT} lightBackground store={ToastStore}/>
        </div>
      }



    // Set the current lost item  
    claim =(lostItem)=>{

        if (lostItem){
            this.setState({
                selectedItem: lostItem,
                showNewClaim:true,
               
            })
            
        }else{
            this.setState({
                selectedItem: null,
                showNewClaim:true,
                
            })
           
        }
    }


    refreshClaims =()=>{
        // if there was a list, then handle here
        this.setState({ showNewClaim: false });
    }

    handlePageChange=(pageNumber) =>{
        this.setState({activePage: pageNumber});
    }

   


    renderNoItems =()=> {

        return(

            <div>
                <h3> No Items Listed in the lost and found</h3>
                <br/><br/><br/><br/>
                <h5> Powered By <a href='https://bounte.net'>BOUNTE </a> </h5>
                </div>
        )
    }


    filterItems = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let filteredItems = this.state.lostItems;
        // rest the pages
        this.setState({
           
            totalItemsCount: this.state.lostItems.length,
            allCount:this.state.lostItems.length,
            pageRangeDisplayed: (this.state.lostItems.length >0) ? Math.ceil(this.state.lostItems.length / this.state.totalPerPage) : 0,
            activePage:1,
            });
       
       
       
        var filteredResults = filteredItems.filter((lostItem) => {
            // Short Description
            var short = (lostItem.shortDescription) ? lostItem.shortDescription.toLowerCase() : '';
            var long = (lostItem.longDescription) ? lostItem.longDescription.toLowerCase() : '';
            var keywords = (lostItem.keywords) ? lostItem.keywords.toLowerCase() : '';

            var searchText = short+long+keywords;
            
            return searchText.indexOf(value.toLowerCase()) !== -1
          
        })
        this.setState({
          filteredItems: filteredResults,
          totalItemsCount: filteredResults.length,
          pageRangeDisplayed: (filteredResults.length >0) ? Math.ceil(filteredResults.length / this.state.totalPerPage) : 0
        })
      }

      onCloseClaimModal = () => {
        this.setState({ showNewClaim: false });
      };

      


  renderCards=()=>{


    const { filteredItems, activePage, totalPerPage } = this.state;
         // Logic for displaying todos
    const indexOfLastLostItem = activePage * totalPerPage;
    const indexOfFirstLost = indexOfLastLostItem - totalPerPage;
    const curentList = filteredItems.slice(indexOfFirstLost, indexOfLastLostItem);
    console.log('Index of First: ' + indexOfFirstLost + ' index of last: ' + indexOfLastLostItem);
    return(

       



      <div style={{ marginTop: '10px' }}>
        <div className="row mt-5 justify-content-center" >
          {curentList=== null && <p>Loading Lost and Found...</p>}
          {
            curentList && curentList.map(lostItem => (
              

                <div className="card mx-2 mb-3" style={{'maxWidth' : '16rem', 'maxHeight' : '500px'}} key={lostItem.id}>
                    
                    <div className="text-white text-center align-middle" style={{'backgroundColor' : this.state.bgColor, height: '90px', align:'middle','verticalAlign': 'middle' }}>
                        <br/>
                        <h5 className="text-white text-center align-middle" >{lostItem.shortDescription}</h5>
                    </div>

                   
                    <h4 > 
                            <img style={{height: '150px',  width: '100%', display: 'block', margin:0}} 
                            src={(lostItem.url) ? lostItem.url : 'data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%22318%22%20height%3D%22180%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20318%20180%22%20preserveAspectRatio%3D%22none%22%3E%3Cdefs%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%23holder_158bd1d28ef%20text%20%7B%20fill%3Argba(255%2C255%2C255%2C.75)%3Bfont-weight%3Anormal%3Bfont-family%3AHelvetica%2C%20monospace%3Bfont-size%3A16pt%20%7D%20%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cg%20id%3D%22holder_158bd1d28ef%22%3E%3Crect%20width%3D%22318%22%20height%3D%22180%22%20fill%3D%22%23777%22%3E%3C%2Frect%3E%3Cg%3E%3Ctext%20x%3D%22129.359375%22%20y%3D%2297.35%22%3EImage%3C%2Ftext%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E'}
                            alt={lostItem.shortDescription}/></h4>
                    
                    <div className="card-body">
                        <p className="text-primary" style={{height: '50px',  width: '100%', display: 'block', margin:5}}>{lostItem.longDescription}</p>
                        <p className="text-info">Found: {LostItemFunctions.formatDate(lostItem.foundDate)}</p>
                    </div>
                 
                <div align="center">
                        <button
                                disabled={this.state.disabled}
                                className="btn btn-outline-secondary"
                                style={{margin:10}}
                                onClick={() => {this.claim(lostItem)}}>
                                Claim This Item
                            </button>
                </div>
              </div>
            ))
          } 
          
        </div>
        <br/>

        <div align='center'  className="text-center">
        <div className="text-center" >
        <Pagination
         className="text-center" 
         activePage={this.state.activePage}
         itemsCountPerPage={this.state.totalPerPage}
         totalItemsCount={this.state.totalItemsCount}
         pageRangeDisplayed={ this.state.pageRangeDisplayed}
         onChange={this.handlePageChange}
        
        
        firstPageText='first'
        lastPageText='last'
       />
       </div>

          <br/><br/>
          <h6> Powered By <a href='https://bounte.net'>BOUNTE </a>&trade; </h6>
          <p><small>copyright 2023. All Rights Reserved</small></p>
       
       
        </div>
        
         
          {this.renderToast()}
        </div>

      )
   
  }


  render() {
    return(
    <div  className='container' style={styles.content}>

           <div className='row justify-content-between' >
                <div className='col-8'> <h4>LOST &amp; FOUND </h4> </div>
                <div className='col-4' >
                    <form className="form-inline my-2 my-lg-0" _lpchecked="1">
                        <input className="form-control mr-sm-2" type="text"  onChange={this.filterItems}  placeholder="Search"/>
                        <img src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAC9ElEQVRoQ+2Y36tNQRTHPzdFRIo8KVJXRKSIiOiKlFLkiYgXSh6U/0KR8sQLESUi4oXcriglD0qJKKWUKCUiSulbs2/Ttn/M2ntmH9321Ok8nDVrrc9as2atOUNMkDU0QTjoQf63TPYZ6TOSKAL90UoU2MZq+4w0Dl2ijdaMrAV2ACPAMmAq8BN4AYwCt4EniXytVBsKsgQ4DWwJcPI+cAx4GSAbTSQEZDdwHphusPodOAhcN+xpJVoHshO4UWDhHaDIa01ymZpXILcLuNnKw8DNVSA6Ts9cHWTqngNHSupAdXMG0L5sqX5WdXHMqkDu5WpCx2Qv8LsiSCp+ZXCbJ6PMbQ0MbGOxMpCNwJin9QOwFPgaYGkO8AqY5cluAh4G7G0sUgZyFjjkaVVEs5oIMbYPuOgJngMOh2xsKlMGooguckrVI5YbDegC+ORl5TWw2KjDJF4G8sMr8gvuKjUpBu4A290mFf00qwKLfBGI+sU3T8kp4LhFqZPV0dIRy9YMQP0lySoC0bH45fqDjF4C9jew7mfkDzAF0HeSVXa03gDDzuJ7YL7Rer5G3gILjTpM4mUgl4E9nqbNbigMVa6x5ponfMX1oND9ZrkyEHXpB542dfR1btKtMzLTTQRZRiVvDUSdjX9+r+rsj4D13g6N6OrsVQUriFuAGmq2HgMbzJ4ZN1SBrAYEM9nTqX6gG+xugR0dpxPAgtxvGueVkY9G30ziddPvATfC55V+doOjnJsL6MHljyR5+eQwdSBy6Kh7VOkmarOSwoSAyHkV/0lgRQCJhkM9g4sylAwmFCTzX+O5ProEVAtyVn1GH73ZVTtPgZWAngGdwVhBAhIyLtIpTEoQEVXB6AbUOyXKbZYapDOYLkA6gekKpA5GF8QaSwHmZbsEqYOZDXxpCtM1SBlM0zfPOPcgQDIYDZcab666h1vV30y1iRoUiBzTpKyGqX8tW69BgrR23lfQg0QNZwRlfUYiBDGqij4jUcMZQVmfkQhBjKriL/HmdzP+LieSAAAAAElFTkSuQmCC' 
                        alt='' width={35} height={35} />
                    </form>
                </div>


                
           </div>
        <div className='row'>
            <div className='col-8'><h6 className='text-info'> Found   {this.state.filteredItems.length} items</h6> </div>
            <div className='col-4'>
            Can't find your item? 
                <button
                                disabled={this.state.disabled}
                                className="btn btn-outline-secondary btn-sm"
                                style={{margin:10}}
                                onClick={() => {this.claim()}}>
                                Click Here
                            </button>
                </div>
        </div>

   


        <hr/>


      
         {
           (this.state.showCards) ? this.renderCards(): this.renderGrid()
           }

          


         <Modal open={this.state.showNewClaim} onClose={this.onCloseClaimModal} center>
          
        {
          // <NewClaim lostItem={this.state.selectedItem} venuePublishID = {this.props.venuePublishID} refreshParent={this.refreshClaims}/>
        } 
        </Modal> 

       


    </div>
   
    )
 }


  
}

const styles = {
    header: {
     
      height: '100vh',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover'
    },
  
    content: {
      width:"100%",
      height:"100%",
      background: 'rgba(255, 255, 255, .01)',
      margin:'10px'
    }
  }


export default withRouter(PortalLostAndFound);